module.exports = __webpack_public_path__ + "static/media/james.f8039822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/james.jpg
// module id = 444
// module chunks = 0